import React, { useContext } from "react";
import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { isEmpty } from "lodash";

import { UserListAdvertisementContext } from "../../../../../../../../context/follow-up-widgets";
import PageDomain from "../../../../domain";

const SubscriptionAttemptTabView = () => {
  const { advertisement } = useContext(UserListAdvertisementContext);

  const [tableData, setTableData] = React.useState([]);
  const [isFetching, setIsFetching] = React.useState(false);

  React.useEffect(() => {
    PageDomain.getUserSubscriptionAttempts({
      memberId: advertisement?.memberId,
      setTableData,
      setIsFetching,
    });
  }, [advertisement]);

  return (
    <Grid
      container
      direction="row"
      className="payment-history-tab-content tab-content"
    >
      {isFetching ? (
        <CircularProgress size={15} />
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>created At</TableCell>
                <TableCell align="center">Payment Gateway</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isEmpty(tableData) ? (
                <TableRow>
                  <TableCell align="center" colSpan={4}>
                    <Typography variant="caption">
                      No Records Available
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                tableData.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {PageDomain.formatDateAndTime(row.createdAt)}
                    </TableCell>
                    <TableCell align="center">{row.ipgType}</TableCell>
                    <TableCell align="center">{row.status}</TableCell>
                    <TableCell align="center">{row.response}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};

export default SubscriptionAttemptTabView;
